// extracted by mini-css-extract-plugin
module.exports = {"nav":"layout_nav__1huzf","isactive":"layout_isactive__3AMMT","fullscreen":"layout_fullscreen__un18J","page_wrapper":"layout_page_wrapper__1De6W","pinned":"layout_pinned__J0-R2"};